import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/api/queryKeys';
import { UserRequest } from '@/api/types';

import api from '@/api';

export const useDeleteUserRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: UserRequest['id']) => api.services.draft.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.userRequests.all });
    },
  });
};
